import { render, staticRenderFns } from "./THGUser.vue?vue&type=template&id=4d082597"
import script from "./THGUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUser.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports